import sumBy from 'lodash/sumBy';

import {
  SavingsProgressResponseEntry,
  SavingsProgressResponseSummary,
} from '@cast/types';
import { toBig } from '@cast/utils';

export const getSummary = (
  items: SavingsProgressResponseEntry[]
): SavingsProgressResponseSummary => {
  const totalSavings = sumBy(items, (item) =>
    toBig(item.downscalingSavings || 0)
      .add(item.spotSavings || 0)
      .toNumber()
  );
  return {
    totalSavings: totalSavings.toFixed(6),
    totalCost: (totalSavings * 4).toString(),
  };
};
